var _path, _path2, _rect, _rect2, _path3, _rect3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.5C28 22.5081 21.5081 28 13.5 28C5.49187 28 0.5 21 0 14.5C0 6.49187 6 0.5 13.5 0C21.5081 0 28 6.49187 28 14.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5392 25.7985C22.0043 25.5008 22.14 24.8823 21.8422 24.4172C21.5444 23.952 20.9259 23.8164 20.4608 24.1142L21.5392 25.7985ZM14 26C7.37258 26 2 20.6274 2 14H0C0 21.732 6.26801 28 14 28V26ZM2 14C2 7.37258 7.37258 2 14 2V0C6.26801 0 0 6.26801 0 14H2ZM14 2C20.6274 2 26 7.37258 26 14H28C28 6.26801 21.732 0 14 0V2ZM26 14C26 16.1874 25.4157 18.2353 24.3952 19.9993L26.1264 21.0007C27.3182 18.9405 28 16.5483 28 14H26ZM20.4608 24.1142C18.5964 25.3079 16.3805 26 14 26V28C16.774 28 19.3624 27.1922 21.5392 25.7985L20.4608 24.1142Z",
    fill: "#1BA397"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 6.75,
    width: 6.5,
    height: 7.5,
    rx: 3.25,
    stroke: "#E1E6F0",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 14,
    height: 10,
    rx: 2,
    fill: "#FFBE40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11H19C20.1046 11 21 11.8954 21 13V19C21 20.1046 20.1046 21 19 21H14V11Z",
    fill: "#FF9F40"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#4D5E80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14V14C14.5523 14 15 14.4477 15 15V17C15 17.5523 14.5523 18 14 18V18V14Z",
    fill: "#3D4B66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8405 22.6225C22.6888 22.6707 22.5444 22.5309 22.5875 22.3776L24.11 16.9768C24.151 16.8311 24.3328 16.7821 24.4416 16.8874L28.2676 20.5907C28.3763 20.696 28.3332 20.8793 28.189 20.9251L22.8405 22.6225Z",
    fill: "#1BA397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityQuestion);
export default __webpack_public_path__ + "static/media/securityQuestion.f4164a1a2f005f486764986402c1f740.svg";
export { ForwardRef as ReactComponent };